import { hot } from 'react-hot-loader';

import BenefitIcon1 from '../components/SvgRobo/BenefitIcon1';
import BenefitIcon2 from '../components/SvgRobo/BenefitIcon2';
import BenefitIcon3 from '../components/SvgRobo/BenefitIcon3';
import BenefitIcon4 from '../components/SvgRobo/BenefitIcon4';

import './ScreenBenefits.scss';



function ScreenBenefits() {
  return (
    <section className="section-benefits">
      <div className="section-benefits__bg" data-aos="fade-in" data-delay="300" data-ofsset="300">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="pre-title"><span>benefits</span></div>
              <h2 className="title">Why Adopt this <span>Fascinating</span> Creature</h2>
              <p className="desc">Prospective owners will have the chance to be early adopters in the new creative community</p>
            </div>
          </div>

          <div className="row">
            <div className="col-6 col-lg-2 col-xl-2 offset-xl-1 mr-fix-1">
              <div className="benefit"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="200">
                <div className="benefit__item">
                  <div className="benefit__item-img benefit__item-img--1"><BenefitIcon1 /></div>
                  <div className="benefit__item-title">Exclusive content</div>
                  <div className="benefit__item-desc">Access to the exclusive and award-winning short film about Roborovski</div>
                </div>
              </div>
            </div>
            <div className="col-6 d-lg-none"></div>

            <div className="col-6 col-lg-2 col-xl-2">
              <div className="benefit"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="400">
                <div className="benefit__item">
                  <div className="benefit__item-img benefit__item-img--2"><BenefitIcon2 /></div>
                  <div className="benefit__item-title">Story is yours</div>
                  <div className="benefit__item-desc">Shape the story of Roborovski with owners input into his future</div>
                </div>
              </div>
            </div>

            <div className="col-6 col-lg-2 offset-lg-3 col-xl-2 offset-xl-3">
              <div className="benefit"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="600">
                {/*<div className="benefit__item">
                  <div className="benefit__item-img benefit__item-img--3"><BenefitIcon3 /></div>
                  <div className="benefit__item-title">Get the royalties</div>
                  <div className="benefit__item-desc">Royalties from the use of artwork shared with any of the NFT owners*</div>
              </div>*/}
                <div className="benefit__item">
                  <div className="benefit__item-img benefit__item-img--4"><BenefitIcon4 /></div>
                  <div className="benefit__item-title">Community</div>
                  <div className="benefit__item-desc">Support the greater art community with a $50,000 grant to take part in the project and broaden the horizons of Roborovski</div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-2 col-xl-2">
              <div className="benefit benefit-last"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="800">
                {/*<div className="benefit__item">
                  <div className="benefit__item-img benefit__item-img--4"><BenefitIcon4 /></div>
                  <div className="benefit__item-title">Community</div>
                  <div className="benefit__item-desc">Support the greater art community with a $50,000 grant to take part in the project and broaden the horizons of Roborovski</div>
                </div>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default hot(module)(ScreenBenefits);
